import axios from 'axios'
import shortly from 'vuex-shortly'
import { SEND_NOTIFICATION_BY_EMAIL } from '@store/types'

const actions = {
  [SEND_NOTIFICATION_BY_EMAIL]: async ({ dispatch }, payload) => {
    const type = payload[0].event || payload[0].partner ? 'campaigns' : 'perks'
    const ids = payload.map(({ id }) => id)
    axios.post(`/notifications/${type}/notify`, { ids })
  }
}

export default shortly({ actions })



// WEBPACK FOOTER //
// ./src/store/modules/common.js